import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=05a2e664&scoped=true"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=05a2e664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a2e664",
  null
  
)

export default component.exports